export default __webpack_public_path__ + "static/media/female-scream.f051bb4e.mp3";